export default {
	methods: {
		_getSettingsByKey(key, subkey, defaultValues = []) {
			let originalSettings;

			if (this.entity[key][subkey]) {
				originalSettings = {...this.entity[key][subkey]};
			} else {
				originalSettings = {
					values: defaultValues,
					default: defaultValues.length > 0 ? defaultValues[0] : null,
					editable: false
				}
			}

			return originalSettings;
		},
		_updateEntityByKey(key, subkey, newSettings) {
			this.entity[key][subkey] = newSettings;
			this.entity[key] = {...this.entity[key]}
		},
		_defaultValueChanged(key, subkey, value, defaultValues = []) {
			let newSettings = this._getSettingsByKey(key, subkey, defaultValues);
			newSettings.default = value;

			this._updateEntityByKey(key, subkey, newSettings);
		},
		_editableChanged(key, subkey, value, defaultValues = []) {
			let newSettings = this._getSettingsByKey(key, subkey, defaultValues);
			newSettings.editable = value;

			this._updateEntityByKey(key, subkey, newSettings);
		},
		_addValue(key, subkey, value) {
			let newSettings = this._getSettingsByKey(key, subkey, []);
			if (!newSettings.values.includes(value)) {
				newSettings.values.push(value);

				if (newSettings.values.length === 1) {
					newSettings.default = value;
				}

				this._updateEntityByKey(key, subkey, newSettings);
			}
		},
		_replaceValues(key, subkey, values) {
			let newSettings = this._getSettingsByKey(key, subkey);
			newSettings.values = values;

			this._updateEntityByKey(key, subkey, newSettings);
		},
		_removeValueByIndex(key, subkey, index) {
			let newSettings = this._getSettingsByKey(key, subkey);
			newSettings.values = [...newSettings.values];
			newSettings.values.splice(index, 1);

			if (newSettings.default
				&& !newSettings.values.includes(newSettings.default)
				&& newSettings.values.length > 0) {
				newSettings.default = newSettings.values[0];
			}

			if (newSettings.values.length > 0) {
				this._updateEntityByKey(key, subkey, newSettings);
			} else {
				this._deleteSubkey(key, subkey);
			}
		},
		_deleteSubkey(key, subkey) {
			if (this.entity[key][subkey]) {
				const newSettings = {...this.entity[key]}
				delete newSettings[subkey];

				this.entity[key] = newSettings;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/deviceConfigs/mixins/settings.js